import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu-shoppingBag",
  "use": "icon-menu-shoppingBag-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-menu-shoppingBag\"><path fill=\"currentColor\" d=\"M5 22q-.825 0-1.412-.587T3 20V8q0-.825.588-1.412T5 6h2q0-2.075 1.463-3.537T12 1t3.538 1.463T17 6h2q.825 0 1.413.588T21 8v12q0 .825-.587 1.413T19 22zM9 6h6q0-1.25-.875-2.125T12 3t-2.125.875T9 6m2.975 8q1.85 0 3.35-1.225t1.475-2.75q0-.425-.275-.725t-.7-.3q-.35 0-.625.225t-.4.675q-.275.95-1.075 1.525t-1.75.575t-1.762-.575T9.15 9.9q-.125-.475-.375-.687T8.175 9q-.425 0-.712.3t-.288.725q0 1.525 1.475 2.75T11.975 14\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/menu/shoppingBag.svg
// module id = GST1
// module chunks = 63